import { env } from '../env';

/**
 * Here goes the global constants
 */
export const APPLICATION_ID = env.REACT_APP_ID_BOUTIQUE;
export const APP_NAME = 'Le programme de cashback';
export const APP_DESCRIPTION = '';
export const DOMAIN_COOKIE = env.REACT_APP_DOMAIN_COOKIE;
export const CONTEXT_ROOT = env.REACT_APP_CONTEXT_ROOT;
export const API_ROOT = env.REACT_APP_API_ROOT || `${env.REACT_APP_CONTEXT_ROOT}/api`;
export const STATIC_ROOT = env.REACT_APP_STATIC_ROOT;
export const LARGE_LOGO_ROOT = env.REACT_APP_LARGE_LOGO_ROOT;
export const LOGO_ROOT = env.REACT_APP_LOGO_ROOT;
export const STATIC_CMS_ROOT = env.REACT_APP_STATIC_CMS_ROOT;
export const STATIC_RESOURCES_ROOT = env.REACT_APP_STATIC_RESOURCES_ROOT;
export const STATIC_ASSOCIATION_LOGO_ROOT = env.REACT_APP_STATIC_ASSOCIATION_LOGO_ROOT;
export const URL_PAGE_FACEBOOK = '';
export const URL_PAGE_TWITTER = '';
export const URL_PAGE_GOOGLEPLUS = '';

export const PAYMENT_THRESHOLD = 5;

export const REWRITE_PREFIX = 'LBAPO_';

export const IS_DEV = env.NODE_ENV === 'development';
export const IS_STAGING = env.REACT_APP_PROFILE === 'preproduction';
export const IS_PROD = env.NODE_ENV === 'production';

export const DATE_FORMAT_REDUXFORM = 'yyyy-mm-dd';

// action input reduxform change
export const REDUX_FORM_CHANGE = '@@redux-form/CHANGE';

export const TIMER_MS_INTERSTITIEL = 10000;
export const TIMER_MS_SSO = 5000;

export const FAQ_ID_WHY_CASHBACK_INVALIDATED =
    env.REACT_APP_FAQ_ID_WHY_CASHBACK_INVALIDATED || null;

export const HOW_IT_WORKS_IDS = env.REACT_APP_HOW_IT_WORKS_IDS;

export const CONTACT_REQUEST_REASON_ID_COMPLAINT =
    env.REACT_APP_CONTACT_REQUEST_REASON_ID_COMPLAINT || null;
export const CONTACT_REQUEST_REASON_ID_UNSUBSCRIBE =
    env.REACT_APP_CONTACT_REQUEST_REASON_ID_UNSUBSCRIBE || null;
export const CONTACT_REQUEST_REASON_ID_CASHBACK_NOT_RECIEVED =
    env.REACT_APP_CONTACT_REQUEST_REASON_ID_CASHBACK_NOT_RECIEVED || null;
export const CONTACT_REQUEST_REASON_ID_INVALID_EBON =
    env.REACT_APP_CONTACT_REQUEST_REASON_ID_INVALID_EBON || null;
export const CONTACT_REQUEST_REASON_ID_CASHBACK_NOT_RECIEVED_FAQ =
    env.REACT_APP_CONTACT_REQUEST_REASON_ID_CASHBACK_NOT_RECIEVED_FAQ || null;

export const PAYMENT_REQUEST_TYPE_NURSERY = Number(env.REACT_APP_PAYMENT_REQUEST_TYPE_NURSERY);
export const PAYMENT_REQUEST_TYPE_IBAN = Number(env.REACT_APP_PAYMENT_REQUEST_TYPE_IBAN);
export const PAYMENT_REQUEST_TYPE_IBAN_TIER = Number(env.REACT_APP_PAYMENT_REQUEST_TYPE_IBAN_TIER);
export const PAYMENT_REQUEST_TYPE_ASSO = Number(env.REACT_APP_PAYMENT_REQUEST_TYPE_ASSO);

export const GA_TRACKING_NUMBER_PLEBICOM = env.REACT_APP_GA_TRACKING_NUMBER_PLEBICOM;
export const GTM_CLIENT_ID = env.REACT_APP_GTM_CLIENT_ID;

export const HIDE_ALO = true;
export const HIDE_FLASHING_TICKET = true;
export const HIDE_CLO = false;

export const CHECKOUT_API_KEY = env.REACT_APP_CHECKOUT_API_KEY;
export const CHECKOUT_RISK_URL = env.REACT_APP_CHECKOUT_RISK_URL;

export const GOOGLE_PAY_MERCHANT_ID = env.REACT_APP_GOOGLE_PAY_MERCHANT_ID;

export const PAYPAL_API_KEY = env.REACT_APP_PAYPAL_API_KEY;



// WEBPACK FOOTER //
// ./src/constants/index.js